import { useIsMobile, useSessionStorage } from '@talos/kyoko';
import { useFeatureFlag } from './useFeatureFlag';

export const DISABLE_MOBILE_LAYOUT_FOR_SESSION = 'disableMobileLayoutForSession';

export function useDisableMobileLayoutForSession() {
  return useSessionStorage(DISABLE_MOBILE_LAYOUT_FOR_SESSION, false);
}

export function getMobileLayoutState({
  enableMobileLayout,
  isMobile,
  isMobileLayoutDisabledForSession,
}: {
  enableMobileLayout: boolean;
  isMobile: boolean;
  isMobileLayoutDisabledForSession: boolean;
}) {
  const canUseMobileLayout = enableMobileLayout && isMobile;

  return {
    isMobileLayout: canUseMobileLayout && !isMobileLayoutDisabledForSession,
    isMobileLayoutDisabledForSession,
    // Do not gate this on live `isMobile`. Forcing desktop sets the viewport to
    // 1280px, which makes CSS-based device detection leave 'mobile' and would
    // otherwise bounce the viewport back to device-width.
    isDesktopLayoutForcedForSession: enableMobileLayout && isMobileLayoutDisabledForSession,
  };
}

export function useMobileLayoutState() {
  const { enableMobileLayout } = useFeatureFlag();
  const isMobile = useIsMobile();
  const [isMobileLayoutDisabledForSession, setIsMobileLayoutDisabledForSession] = useDisableMobileLayoutForSession();

  return {
    ...getMobileLayoutState({
      enableMobileLayout,
      isMobile,
      isMobileLayoutDisabledForSession,
    }),
    setIsMobileLayoutDisabledForSession,
  };
}
